/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSupportRequestCategory } from '../models/db_DropdownSupportRequestCategory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportRequestCategories {
    /**
     * Get a list of support request categories
     * @returns db_DropdownSupportRequestCategory OK
     * @throws ApiError
     */
    public static listSupportRequestCategories(): CancelablePromise<Array<db_DropdownSupportRequestCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-request-categories',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
